var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvaluation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14.164C18.0585 15.5665 17.1812 16.7917 15.9956 17.6614C14.81 18.5311 13.3779 19.0001 11.9075 19C10.0755 19 8.31857 18.2723 7.02316 16.9769C5.72775 15.6814 5 13.9245 5 12.0925C4.99996 10.6221 5.46888 9.19004 6.33859 8.00444C7.2083 6.81884 8.43347 5.94152 9.83601 5.5",
    stroke: "#707070",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9348 9.96024C19.54 8.55465 18.7905 7.27419 17.7582 6.24184C16.7258 5.20949 15.4453 4.45996 14.0398 4.06523C12.8068 3.72098 11.75 4.79048 11.75 6.06998V11.0905C11.75 11.7302 12.269 12.2492 12.9088 12.2492H17.9293C19.2095 12.2492 20.279 11.1925 19.9348 9.96024Z",
    stroke: "#707070",
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/evaluation.fa257c7e6fd8a6d874f660f5c8c54ebb.svg";
export { ForwardRef as ReactComponent };